
export default {
  namespaced: true,
  state: () => ({
    getDotor: [],
    articlelist: [],
    videolist: [],
    videolist2: [],
  }),
};



// WEBPACK FOOTER //
// src/store/home/home.js